import {GoogleAIBackend, getAI, getGenerativeModel} from "firebase/ai";
import firebase from "../core/firebase";

/**
 * Firebase AI Logic (Gemini) — usado no cliente para sugestões leves (ex.: nome do produto).
 * Requer AI Logic habilitado no projeto Firebase (Console → Build → Firebase AI Logic).
 */
export function getSymplouGenerativeModel() {
  const ai = getAI(firebase.app, {backend: new GoogleAIBackend()});
  return getGenerativeModel(ai, {
    model: "gemini-2.5-flash",
  });
}
